import { FETCH_SECURITIES, FETCH_SECURITIES_EDGES, SET_SECURITIES_STATE } from '../../actions/types';

const INITIAL_STATE = {
  loading: true,
  error: '',
  all: [],
  totals: {},
};

export default function securityReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_SECURITIES_STATE:
      return {
        ...state,
        loading: action.payload.loading,
        error: action.payload.error,
      };
    case FETCH_SECURITIES:
      return {
        ...state,
        all: action.payload.result,
      };
    case FETCH_SECURITIES_EDGES:
      return {
        ...state,
        totals: {
          ...action.payload.totals,
        },
      };
    default:
      return state;
  }
}
